@if (state.vm$ | async; as data) {
  <ui-browse-filter
    [form]="filterForm"
    pageKey="katalog-skupin-sablon"
    collapsibleLabel="Rozšířené filtrování"
    [cy]="{ search: 'katalog-skupin-btn-submit-kriteria', clear: 'katalog-skupin-btn-smazat-kriteria' }"
    (submitted)="submitFilter()"
    (cleared)="clearFilter()">
    <p description class="text-(length:--font-size-body-l) mt-0 mb-8">
      Zadejte kritéria skupin typu oprávnění k zastupování, které chcete vyhledat.
    </p>
    <reza-katalog-skupin-sablon-filter></reza-katalog-skupin-sablon-filter>
  </ui-browse-filter>

  <p-table
    uiBrowseTable
    scrollHeight=""
    (onLazyLoad)="state.onLazyLoad($event)"
    [value]="data.result.content || []"
    [rows]="data.filter.pageAndSortList?.count"
    [first]="data.filter.pageAndSortList?.start"
    [totalRecords]="data.result.total || 0">
    <ng-template #header>
      <tr>
        <th>Kód skupiny šablon</th>
        <th>Název skupiny šablon</th>
        <th>Datum vytvoření</th>
        <th>Datum poslední změny</th>
        <th>Datum ukončení</th>
        <th>Editor</th>
        <th>Status</th>
      </tr>
    </ng-template>
    <ng-template #body let-skupina>
      <tr>
        <td>
          <a [routerLink]="" (click)="downloadPdf(skupina.id)" target="_blank" class="underline">
            {{ skupina.kodSkupiny }}
          </a>
        </td>
        <td>{{ skupina.nazevSkupiny }}</td>
        <td>{{ skupina.datumVytvoreni | date: 'dd.MM.yyyy' }}</td>
        <td>{{ skupina.datumPosledniZmeny | date: 'dd.MM.yyyy' }}</td>
        <td>{{ skupina.datumUkonceni | date: 'dd.MM.yyyy' }}</td>
        <td>
          @if (skupina.editor?.kodOvm && skupina.editor?.nazevOvm) {
            {{ skupina.editor.kodOvm }} - {{ skupina.editor.nazevOvm }}
          } @else {
            {{ skupina.editor?.kodOvm || skupina.editor?.nazevOvm }}
          }
        </td>
        <td>
          <ui-status-indicator
            [statusLabels]="statusSkupinySablonOptions"
            [status]="skupina.status"></ui-status-indicator>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ui-buttons>
    <button class="m-1 mb-6" (click)="goBack()" pButton data-cy="katalog-skupin-zpet">
      <span pButtonLabel>Zpět</span>
    </button>
  </ui-buttons>
}
